module.exports = __webpack_public_path__ + "static/zuri-hybrid-vtol-medium-range-cities-5e891ee7521f7f55dd6ddc09236adef2.png";